module.exports = __webpack_public_path__ + "static/media/interiors_rendering.6e1b44ce.jpg";